<script setup>
defineProps({
  title: {
    type: String,
    default: ''
  },
  body: {
    type: String,
    default: ''
  },
  type: {
    type: String,
    default: ''
  }
})
</script>

<template>
  <div class="info__inner">
    <h2 class="heading">
      天気図解説（9時）
    </h2>
    <div class="block">
      <div class="title">
        {{ title }}
      </div>
      <p class="text">
        {{ body }}
      </p>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.info__inner {
  display: flex;
  flex-direction: column;
  gap: 15px;
}
.heading {
  color: #303030;
  font-size: 18px;
  font-weight: bold;
  line-height: 20px;
  letter-spacing: 0.25px;
}
.block {
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.title {
  color: #101010;
  font-size: 15px;
  font-weight: 600;
  line-height: 15px;
}
.text {
  color: #000;
  font-size: 15px;
  line-height: 25.05px;
}
@media (min-width: 830px) {
  .heading {
    font-size: 22px;
    line-height: 22px;
  }
}
// .link {
//   position: relative;
//   width: min(370px, 100%);
//   margin-inline: auto;
//   padding: 8px 10px 6px;
//   border-radius: 2px;
//   border: 1px solid #3569C0;
//   background-color: #fff;
//   color: #3569C0;
//   font-size: 18px;
//   font-weight: 600;
//   line-height: 19px;
//   text-align: center;
//   &::after {
//     position: absolute;
//     bottom: 4px;
//     right: 4px;
//     width: 9px;
//     height: 9px;
//     background-color: #3569C0;
//     clip-path: polygon(100% 0, 100% 100%, 0 100%);
//     content: '';
//   }
//   @media (any-hover: hover) {
//     transition: opacity .2s ease-in-out;
//     &:hover {
//       opacity: .6;
//     }
//   }
// }
</style>
